<hmf-progress-ring
	[variant]="'points'"
	[targetBalance]="pointsTarget"
	[currentBalance]="currentPointBalance"
	[size]="size">
</hmf-progress-ring>
